/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useOkapiKy } from '@folio/stripes/core';

export default function useQueryString(query) {
  const okapiKy = useOkapiKy();
  const [queryString, setQueryString] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!query || query === '') {
      setQueryString(null);
      setError(null);
      return;
    }

    let cancelled = false;
    setIsLoading(true);

    const { view, fieldAliasMap, ...cubeQuery } = typeof query === 'object' ? query : {};

    okapiKy.post('cube/sql', { json: { query: cubeQuery } }).json()
      .then((res) => {
        if (!cancelled) setQueryString(res.sql ?? res);
      })
      .catch((e) => {
        if (!cancelled) setError(e);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => { cancelled = true; };
  }, [JSON.stringify(query)]);

  return [queryString, error, isLoading];
}
